import { ConnectedPosition } from '@angular/cdk/overlay';

export const ASTRAL_DROPDOWN_OVERLAY_VIEWPORT_MARGIN = 0;

/** Shared placement rules for Astral controls whose panels are rendered by Angular CDK. */
export function getAstralDropdownOverlayPositions(): ConnectedPosition[] {
  return getAstralOverlayPositions(false);
}

/** Placement rules for compact popovers that should avoid covering the next form row. */
export function getAstralPopoverOverlayPositions(): ConnectedPosition[] {
  return getAstralOverlayPositions(true);
}

/** Keeps a panel flush with its trigger while still respecting the viewport width. */
export function getAstralDropdownOverlayWidth(triggerWidth: number, viewportWidth?: number): number {
  if (!viewportWidth) {
    return triggerWidth;
  }

  return Math.min(triggerWidth, Math.max(0, viewportWidth - ASTRAL_DROPDOWN_OVERLAY_VIEWPORT_MARGIN * 2));
}

function getAstralOverlayPositions(preferAbove: boolean): ConnectedPosition[] {
  const above: ConnectedPosition = {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
    offsetY: -4,
  };
  const below: ConnectedPosition = {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    offsetY: 4,
  };

  return preferAbove ? [above, below] : [below, above];
}
